const SENSITIVE_PARAM =
  /(^|[?&"])(token|email|payment_intent_client_secret)=[^&#"\\\s]*/gi;
const AUTH_EMAIL_PATH = /(\/store\/auth\/)[^/?#"\\\s]*(?:@|%40)[^/?#"\\\s]*/gi;

/**
 * Redacts what a URL can carry about a buyer: the `token` and `email` query values of the
 * password-definition link, the Stripe `payment_intent_client_secret` of a payment return,
 * and the email in `/store/auth/{email}`.
 */
export function redactUrl(value: string): string {
  return value
    .replace(SENSITIVE_PARAM, '$1$2=REDACTED')
    .replace(AUTH_EMAIL_PATH, '$1REDACTED');
}
